import { loadable } from 'nordic/lazy';

export default loadable(() => import('./header.mobile'));
